import React from 'react';
import { X } from 'lucide-react';

interface ImageModalProps {
    isOpen: boolean;
    onClose: () => void;
    imageSrc: string;
    imageAlt: string;
    fallbackSrc?: string;
}

const ImageModal: React.FC<ImageModalProps> = ({
    isOpen,
    onClose,
    imageSrc,
    imageAlt,
    fallbackSrc
}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={handleBackdropClick}
        >
            <div className="relative">
                <button
                    className="absolute -top-8 -right-2 p-1 text-white hover:text-gray-300 transition-colors"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    <X size={24} />
                </button>
                <img
                    src={imageSrc || fallbackSrc}
                    alt={imageAlt}
                    className="max-h-[80vh] max-w-[90vw] object-contain rounded-lg"
                />
            </div>
        </div>
    );
};

export default ImageModal; 